import '../styles/EndCTA.css';
import React from 'react';
import { FaFacebookF, FaInstagram, FaLinkedinIn, FaMapMarkerAlt, FaEnvelope, FaPhoneAlt, FaClock } from 'react-icons/fa';
import { useEndCTAContent } from '../../ViewModel/EndCTAViewModel.js';
import { sanitizeNavigationHref } from '../../Model/Services/urlSafetyService.js';

function EndCTA() {
    const { contacts, socials } = useEndCTAContent();

    const contactIcons = {
        location: <FaMapMarkerAlt />,
        email: <FaEnvelope />,
        phone: <FaPhoneAlt />,
        hours: <FaClock />,
    };

    return (
        <section className="endcta">
            <div className="endcta-columns">
                <article className="endcta-col endcta-col--contact">
                    <h1>Kontakt</h1>
                    <ul className="endcta-contact">
                        {contacts.map((item, idx) => (
                            <li key={`${item.type}-${idx}`}>
                                <span className="ico">{contactIcons[item.type]}</span>
                                {item.text.includes('\n') ? (
                                    <>{item.text.split('\n').map((line, i) => (<React.Fragment key={i}>{line}{i === 0 && <br />}</React.Fragment>))}</>
                                ) : (
                                    item.text
                                )}
                            </li>
                        ))}
                    </ul>
                </article>

                <article className="endcta-col endcta-col--social">
                    <h1 id='kontakt'>Följ oss</h1>
                    <p className="endcta-social-copy">Häng med i våra kanaler för nyheter och tips.</p>
                    <div className="endcta-social">
                        {socials.map((social) => (
                            <a key={social.type} aria-label={social.label} href={sanitizeNavigationHref(social.href)}>
                                {social.type === 'facebook' && <FaFacebookF />}
                                {social.type === 'instagram' && <FaInstagram />}
                                {social.type === 'linkedin' && <FaLinkedinIn />}
                            </a>
                        ))}
                    </div>
                </article>
            </div>
        </section>
    );
}

export default EndCTA;
